import React from "react";
import Styles from "./styles/MessageCardStyle.module.css";
import { Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from "@mui/material";
import {
  convertToAMPM,
  formatDate,
  formatTableNumber,
} from "../../utils";

const columns = [
  { id: 'name', label: 'Item Name', minWidth: 100 },
  { id: 'qty', label: 'Quantity', minWidth: 40 },
  {
    id: 'unit_price',
    label: 'Price Per Unit',
    format: (value) => value ? Math.abs(value).toFixed(2) : 'N/A',
    minWidth: 70,
  },
  {
    id: 'rounded_total',
    label: 'Total Price',
    minWidth: 60,
  },
  {
    id: 'modifiers',
    label: 'Special Notes',
    minWidth: 125,
  },
];

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#797979',
    color: theme.palette.common.white,
    fontSize: 10,
    border: '0.5px solid black',
    padding: '8px'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 8,
    whiteSpace: 'wrap',
    border: '0.5px solid black',
    padding: '8px'
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
}));

const StyledTable = styled(Table)({
  borderCollapse: 'collapse',
});

const ReservationCard = ({ data, rows }) => {

  const totalAmount = data?.billAmount
  const discountAmount = totalAmount * (data?.discountPercentage / 100)
  const finalAmount = data?.payableAmount

  return (
    <div className={Styles.container} style={{border:'1px solid black', height:'550px'}}>
      <div className={Styles.reservationInfoWrapper}>
        <p className={Styles.userName}>{data?.name}</p>
        <div className={Styles.flexContainer}>
          <div>
            {data?.tableNumberDetails && (
              <p className={Styles.table}>
                Table No.:{" "}
                {formatTableNumber(
                  data?.tableNumberDetails
                    ? data.tableNumberDetails +
                    (data?.pdrNumberDetails
                      ? `, ${data.pdrNumberDetails}`
                      : "")
                    : data?.pdrNumberDetails
                )}
              </p>
            )}
            <p className={Styles.message}>
              No. of People:{" "}
              {data?.peopleCount?.toString()?.length === 1
                ? "0" + data?.peopleCount
                : data?.peopleCount}
            </p>

            <p className={Styles.dateTime}>
              {data?.booking_date ? formatDate(data?.booking_date) : null}{" "}
              &nbsp;
              {data?.booking_time ? convertToAMPM(data?.booking_time) : null}
            </p>
          </div>


          <div className={Styles.uidMessageWrapper}>
            <p className={Styles.message}>
              Spending: {totalAmount || "0.00"}
            </p>

            {/* {data?.spending ? ( */}
              {/* <p className={Styles.message}>
                Settlement Type: {data?.billRecivedFrom || "N.A"}
              </p> */}
            {/* ) : null} */}

            {data?.username ? (
              <p className={Styles.message}>
                uid: {data?.username || "N.A"}
              </p>
            ) : null}
          </div>

        </div>

        {/* <p className={Styles.dateTime}>
          {data?.booking_date ? formatDatetime(data?.booking_date, true) : null}{" "}
          &nbsp;
          {data?.booking_time ? convertToAMPM(data?.booking_time) : null}
        </p> */}
        <div style={{marginTop:'10px'}}>
          <p className={Styles.userName}>Line items of consumption</p>
          <Paper sx={{ width: '100%', overflow: 'hidden', borderRadius:'0px' }}>
            <TableContainer
              sx={{
                maxHeight: 264,
                overflowY: 'auto',
                overflowX: 'auto', // Hides horizontal scroll
                scrollbarWidth: 'thin', // Firefox: Reduces scrollbar width
                scrollbarColor: 'rgba(0, 0, 0, 0.5) transparent', // Firefox: Custom scrollbar color
                '&::-webkit-scrollbar': {
                width: '2px', // Chrome, Safari, Edge: Reduce vertical scrollbar width
                borderRadius: '4px', // Add border-radius to scrollbar track
              },
              '&::-webkit-scrollbar-thumb': {
                display:'none'
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: 'rgba(0, 0, 0, 0.1)', // Light track color
                borderRadius: '4px', // Rounded scrollbar track
              },
              }}
            >
              <StyledTable stickyHeader aria-label="sticky table">
                <TableHead sx={{}}>
                  <StyledTableRow>
                    {columns.map((column) => (
                      <StyledTableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                      >
                        {column.label}
                      </StyledTableCell>
                    ))}
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                {rows.length > 0 ? (
                    rows.map((row, index) => (
                      <StyledTableRow key={index}>
                        {columns.map((column) => (
                          <StyledTableCell key={column.id}>
                            {column.id === "unit_price" || column.id === "rounded_total"
                              ? `₹${column.format ? column.format(row[column.id]) : row[column.id]}`
                              : column.id === "modifiers"
                              ? row[column.id]?.map((dt, i) => <li key={i}>{dt.name}</li>)
                              : row[column.id]}
                          </StyledTableCell>
                        ))}
                      </StyledTableRow>
                    ))
                  ) : (
                    <StyledTableRow>
                      <StyledTableCell colSpan={columns.length} align="center">
                        No Records Found
                      </StyledTableCell>
                    </StyledTableRow>
                  )}
                </TableBody>
              </StyledTable>
            </TableContainer>
          </Paper>
        </div>
              
        <div style={{marginTop:'15px'}}>
          <p className={Styles.userName}>Bill Summary</p>
          <p>
            {`Total Amount Before Discount: ₹ ${totalAmount || "0.00"}`}
          </p> 
          <p>
            {`Discount Applied: ₹ ${discountAmount || "0.00"}`}
          </p>
          <p>
            {`Final Bill Amount: ₹ ${finalAmount || "0.00"}`}
          </p>
          <p>
            Settlement Type: {data?.billRecivedFrom || "N.A"}
          </p>
        </div>

        {data?.cancelationReason ? (
          <>
            <p className={Styles.message}>
              Status: Cancelled ({data?.cancelationReason})
            </p>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default ReservationCard;
